<template>
  <RouterLink v-if="to" :to="to">
    {{ toLang }}
  </RouterLink>
</template>

<script>
export default {
  name: 'LangSwitchLink',
  inject: ['mq'],
  computed: {
    to() {
      if (!this.currentRouteName || !this.toLang) return null

      return {
        name:
          this.toLang !== this.$i18n.fallbackLocale
            ? `${this.currentRouteName.split(':')[0]}:${this.toLang}`
            : this.currentRouteName.split(':')[0],
        params: this.$route.params,
        query: this.$route.query,
      }
    },
    currentRouteName() {
      return this.$route.name ? String(this.$route.name) : null
    },
    toLang() {
      return this.$i18n.availableLocales.find((lang) => lang !== this.$i18n.locale)
    },
  },
}
</script>
